import { ChangeEvent, useEffect } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext"; // Import InputText
import { Button } from "primereact/button"; // Import Button
import { useDispatch, useSelector } from "react-redux";
import {
  setNewPassword,
  setPassword,
  setOTPPopupOpen,
  restPassword,
  generateOTP,
} from "src/redux/slices/bMCProfileSlice";
import { isNullOrWhiteSpace, isCivilDefenseUser } from "src/utils/helpers";
import { useTranslation } from "react-i18next";
import OTP from "../OTP/OTP";
import { handleResponse } from "src/services/apiServices";
import { toast } from "react-toastify";
import { OTPType, RoutePaths } from "src/resources/enum";
import { useNavigate } from "react-router";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { password, newPassword, confirmNewPassword, BMCData } = useSelector(
    (state: any) => state.bMCProfile
  );

  const { t } = useTranslation(["common", "user"]);
  const handleRestPassword = async (e: any) => {
    e.preventDefault();
    if (password === newPassword) {
      toast.error(t("sameOldAndNewPassword"));
    } else if (newPassword !== confirmNewPassword) {
      toast.error(t("newAndConfirmationPasswordNotSame"));
    } else if (newPassword.length < 8) {
      toast.error(t("passwordLength"));
    } else {
      dispatch(generateOTP(OTPType.Email, BMCData.email) as any);
      dispatch(setOTPPopupOpen(true) as any);
    }
  };
  const handlePassword = (e: ChangeEvent<HTMLInputElement>): void => {
    dispatch(setPassword(e.target.value));
  };

  const handleNewPassword = (e: ChangeEvent<HTMLInputElement>): void => {
    dispatch(
      setNewPassword({
        field: e.target.name,
        value: e.target.value,
      })
    );
  };
  const resetInputFields = () => {
    dispatch(setPassword(""));
    dispatch(setNewPassword({ field: "newPassword", value: "" }));
    dispatch(setNewPassword({ field: "confirmNewPassword", value: "" }));
  };
  const afterSuccessChangePassword = () => {
    toast.success(t("passwordChangedSuccessfully"));
    resetInputFields();
    navigate(RoutePaths.Dashboard);
  };
  const restPasswordFn = async (isValidOTP: boolean) => {
    if (isValidOTP) {
      dispatch(restPassword(afterSuccessChangePassword) as any);
      dispatch(setOTPPopupOpen(false) as any);
    }
  };
  useEffect(() => {
    return () => resetInputFields();
  }, []);

  return (
    <>
      <div
        className="d-flex justify-content-center align-items-center login"
      // style={{ minHeight: "100vh" }}
      >
        <Card className="login-card">
          <div className="card-header d-flex mb-4 justify-content-center">
            <h1>{t("changePasswordTitle")}</h1>
          </div>

          <form
            className="d-flex flex-column justify-content-center"
            onSubmit={handleRestPassword}
          >
            <div className="form-control">
              <label htmlFor="password">{t("oldPassword")}</label>
              <InputText
                id="password"
                name="password"
                type="password"
                placeholder={t("oldPasswordLabel")}
                className="w-100"
                autoComplete="false"
                onChange={handlePassword}
                value={password}
              />
            </div>
            <div className="form-control">
              <label htmlFor="new-password">{t("newPassword")}</label>
              <InputText
                id="new-password"
                name="newPassword"
                type="password"
                placeholder={t("newPasswordPlaceholder")}
                className="w-100"
                autoComplete="false"
                onChange={handleNewPassword}
                value={newPassword}
              />
            </div>
            <div className="form-control">
              <label htmlFor="confirm-new-password">
                {t("confirmNewPassword")}
              </label>
              <InputText
                id="confirm-new-password"
                name="confirmNewPassword"
                type="password"
                placeholder={t("confirmNewPasswordPlaceholder")}
                className="w-100"
                autoComplete="false"
                onChange={handleNewPassword}
                value={confirmNewPassword}
              />
            </div>
            <Button
              type="submit"
              label={t("reset")}
              className="primary-btn border-radius-100"
              disabled={
                isNullOrWhiteSpace(password) ||
                isNullOrWhiteSpace(newPassword) ||
                isNullOrWhiteSpace(confirmNewPassword)
              }
            />
          </form>
        </Card>
      </div>
      <OTP callbackFn={restPasswordFn} handleRegenerateOTP={handleRestPassword} otpType={OTPType.Email} />
    </>
  );
};

export default ChangePassword;
